
import { z } from "zod";

export const ConversationItemTypeValues = ["PHONE_CALL", "EMAIL", "MESSAGE", "SMS_MESSAGE"] as const;
export const ConversationItemTypeSchema = z.enum(ConversationItemTypeValues);
export const ConversationItemType = ConversationItemTypeSchema.enum;
export type ConversationItemType = (typeof ConversationItemTypeValues)[number];
